module.exports = __webpack_public_path__ + "img/farzana-christopher-103.e4df17ae.jpg";